import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import FallbackErrorMessage from '../../../../utils/errors/FallbackMessage'
import { EInvoiceDetails } from '../components'

export const EInvoiceDetailsPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <EInvoiceDetails />
    </ErrorBoundary>
  )
}
